export function getProductImageSrc(product) {
  if (product.image) return product.image;
  const firstImage = product?.images?.[0];
  return typeof firstImage === 'object' ? firstImage?.url : firstImage;
}
